import { type FC } from 'react';

import { Tag } from '@wk/components-react16';

import type { OnboardingExceptionApprovalStatus } from '@/features/onboarding/types/onboarding.types';

import OnboardingExceptionApprovalTag from './OnboardingExceptionApprovalTag';

interface OnboardingCheckpointStatusTagsProps {
  exceptionApprovalStatus: OnboardingExceptionApprovalStatus;
  isNew: boolean;
  isPreview: boolean;
  requiresParameters: boolean;
}

const OnboardingCheckpointStatusTags: FC<
  OnboardingCheckpointStatusTagsProps
> = ({
  exceptionApprovalStatus,
  isNew,
  isPreview,
  requiresParameters,
}) => (
  <div className="flex flex-wrap gap-2">
    {requiresParameters ? (
      <Tag color="orange">Requires parameters</Tag>
    ) : null}
    {isNew ? <Tag color="green">New</Tag> : null}
    {isPreview ? (
      <Tag color="gray" contrastMode="light">
        Preview
      </Tag>
    ) : null}
    <OnboardingExceptionApprovalTag
      approvalStatus={exceptionApprovalStatus}
    />
  </div>
);

export default OnboardingCheckpointStatusTags;
